module.exports = __webpack_public_path__ + "static/shoe-layers-2-63e573af05eea8ae7e3e176a423b6b93.png";